import React from 'react';

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/14376776164?text=Hi%2C%20I%27m%20interested%20in%20tutoring%20sessions"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-button"
      className="fixed bottom-20 right-4 z-[9998] w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:bg-[#20bd5a] hover:scale-110 transition-all duration-300"
    >
      <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.96A15.908 15.908 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.335 22.594c-.39 1.1-1.932 2.014-3.178 2.28-.854.18-1.968.324-5.72-1.23-4.802-1.988-7.892-6.856-8.132-7.174-.23-.318-1.932-2.574-1.932-4.908s1.222-3.48 1.656-3.958c.434-.478.948-.598 1.264-.598.316 0 .632.002.908.016.292.014.682-.11 1.068.814.39.94 1.33 3.246 1.448 3.482.118.236.196.51.04.828-.158.318-.236.516-.474.796-.236.28-.498.624-.712.838-.236.236-.482.492-.208.966.276.474 1.226 2.022 2.632 3.274 1.81 1.612 3.336 2.112 3.81 2.348.474.236.75.198 1.028-.118.276-.318 1.186-1.382 1.502-1.858.316-.478.632-.394 1.066-.236.434.158 2.756 1.3 3.228 1.538.474.236.79.356.908.554.118.198.118 1.146-.272 2.246z"/>
      </svg>
    </a>
  );
}
